webpackJsonp([1],{

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidDemoWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return genOneUid; });


var DEFAULT_DEMO_WIDTH = 50;
var MIN_DEMO_WIDTH = 20;
var MAX_DEMO_WIDTH = 75;

var isDemoWidthValid = function isDemoWidthValid(width) {
  if (isNaN(width)) return false;
  if (width < MIN_DEMO_WIDTH) return false;
  if (width > MAX_DEMO_WIDTH) return false;

  return true;
};

var getValidDemoWidth = function getValidDemoWidth(width) {
  return isDemoWidthValid(Number(width)) ? Number(width) : DEFAULT_DEMO_WIDTH;
};

var genOneUid = function genOneUid() {
  var uidArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var uid = void 0;

  do {
    uid = Math.random().toString(36).slice(2, 6);
  } while (uidArr.includes(uid));

  return uid;
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Container__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Container',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Container___default.a
  }]
}));

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(96),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(37);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Demo__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Demo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Demo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ctrl__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ctrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Ctrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventHub__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Container',

  components: {
    CompDemo: __WEBPACK_IMPORTED_MODULE_2__Demo___default.a,
    CompCtrl: __WEBPACK_IMPORTED_MODULE_3__Ctrl___default.a
  },

  data: function data() {
    return {
      title: 'Flex Playground',
      demoProps: {
        fd: 'row',
        fw: 'nowrap',
        jc: 'flex-start',
        ai: 'stretch',
        ac: 'stretch'
      }
    };
  },
  created: function created() {
    var _this = this;

    var _$route$query$demoPro = this.$route.query.demoProps,
        demoProps = _$route$query$demoPro === undefined ? '{}' : _$route$query$demoPro;


    try {
      this.demoProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.demoProps, JSON.parse(demoProps));
    } catch (e) {
      this.demoProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.demoProps, JSON.parse(decodeURIComponent(demoProps)));
    }

    __WEBPACK_IMPORTED_MODULE_4__EventHub__["a" /* default */].$on('props-change', function (newDemoProps) {
      _this.demoProps = newDemoProps;
    });
  },


  watch: {
    demoProps: function demoProps(newVal) {
      this.$router.push({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          demoProps: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newVal)
        })
      });
    }
  }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventHub__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils___ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ctrl',

  data: function data() {
    return {
      title: 'Ctrl',
      demoWidth: 50,
      containerDescArr: ['flex-flow: flex-direction \u548C flex-wrap \u7684\u7F29\u5199\u5F62\u5F0F;', 'flex-direction: \u8BBE\u7F6E\u4E3B\u8F74\u65B9\u5411\uFF0C\u786E\u5B9A\u5F39\u6027\u5B50\u5143\u7D20\u7684\u6392\u5217\u65B9\u5F0F;', 'flex-wrap: \u5F53\u5F39\u6027\u5B50\u5143\u7D20\u8D85\u51FA\u5F39\u6027\u5BB9\u5668\u8303\u56F4\u65F6\u662F\u5426\u6362\u884C;', 'justify-content: \u4E3B\u8F74\u4E0A\u7684\u5BF9\u9F50\u65B9\u5F0F;', 'align-items: \u4FA7\u8F74\u4E0A\u7684\u5BF9\u9F50\u65B9\u5F0F;', 'align-content: \u5F53\u4FA7\u8F74\u4E0A\u6709\u7A7A\u95F4\u65F6\uFF0C\u4FA7\u8F74\u7684\u5BF9\u9F50\u65B9\u5F0F;'],
      containerFlexPropArr: [{
        prefix: 'fd',
        name: 'flex-direction',
        itemValues: ['row', 'row-reverse', 'column', 'column-reverse']
      }, {
        prefix: 'fw',
        name: 'flex-wrap',
        itemValues: ['nowrap', 'wrap', 'wrap-reverse']
      }, {
        prefix: 'jc',
        name: 'justify-content',
        itemValues: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around']
      }, {
        prefix: 'ai',
        name: 'align-items',
        itemValues: ['stretch', 'flex-start', 'flex-end', 'center', 'baseline']
      }, {
        prefix: 'ac',
        name: 'align-content',
        itemValues: ['stretch', 'flex-start', 'flex-end', 'center', 'space-between', 'space-around']
      }],
      itemDescArr: ['order: \u5B50\u5143\u7D20\u95F4\u7684\u6392\u5217\u987A\u5E8F;', 'flex-grow: \u6269\u5C55\u6BD4\u7387\uFF0C\u7B97\u6CD5\u4E3A\u5F53\u524D\u5143\u7D20\u7684\u503C\u4E3A\u5206\u5B50\uFF0C\u6240\u6709\u5143\u7D20\u7684\u8BE5\u503C\u4F5C\u4E3A\u5206\u6BCD\uFF0C\u6765\u5206\u914D\u591A\u4F59\u7684\u7A7A\u95F4\uFF08\u6570\u503C\u8D8A\u5927\u6269\u5C55\u8D8A\u591A\uFF09;', 'flex-shrink: \u6536\u7F29\u6BD4\u7387\uFF0C\u7B97\u6CD5\u540C\u4E0A\uFF0C\u6309\u6BD4\u7387\u6536\u7F29\uFF08\u6570\u503C\u8D8A\u5927\u6536\u7F29\u8D8A\u591A\uFF09;', 'flex-basis: \u4F38\u7F29\u524D\u7684\u9ED8\u8BA4\u5927\u5C0F\u503C\uFF0C\u76F8\u5F53\u4E8E width/height \u5C5E\u6027;', 'align-self: \u4F5C\u7528\u4E8E\u5F53\u524D\u5B50\u5143\u7D20\uFF0C\u8986\u76D6 container \u7684 align-items \u5C5E\u6027;']
    };
  },


  props: {
    demoProps: {
      fd: {
        type: String,
        default: 'row'
      },
      fw: {
        type: String,
        default: 'nowrap'
      },
      jc: {
        type: String,
        default: 'flex-start'
      },
      ai: {
        type: String,
        default: 'stretch'
      },
      ac: {
        type: String,
        default: 'stretch'
      }
    }
  },

  created: function created() {
    var _$route$query$demoWid = this.$route.query.demoWidth,
        demoWidth = _$route$query$demoWid === undefined ? 50 : _$route$query$demoWid;


    this.demoWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils___["a" /* getValidDemoWidth */])(demoWidth);
  },


  computed: {
    ctrlContainerStyle: function ctrlContainerStyle() {
      return { flex: 100 - this.demoWidth };
    }
  },

  methods: {
    widthOnChange: function widthOnChange() {
      __WEBPACK_IMPORTED_MODULE_1__EventHub__["a" /* default */].$emit('ctrl-width-change', this.demoWidth);
    },
    propOnChange: function propOnChange(prop) {
      __WEBPACK_IMPORTED_MODULE_1__EventHub__["a" /* default */].$emit('props-change', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.demoProps, prop));
    }
  },

  watch: {
    demoWidth: function demoWidth(newVal) {
      this.$router.push({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          demoWidth: newVal
        })
      });
    }
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EventHub__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Item__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils___ = __webpack_require__(21);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Demo',

  components: {
    CompDemoItem: __WEBPACK_IMPORTED_MODULE_6__Item___default.a
  },

  data: function data() {
    return {
      title: 'Demo',
      demoItems: [],
      demoItemProps: {},
      width: 50
    };
  },


  props: {
    demoProps: {
      fd: {
        type: String,
        default: 'row'
      },
      fw: {
        type: String,
        default: 'nowrap'
      },
      jc: {
        type: String,
        default: 'flex-start'
      },
      ai: {
        type: String,
        default: 'stretch'
      },
      ac: {
        type: String,
        default: 'stretch'
      }
    }
  },

  created: function created() {
    var _this = this;

    var _getOneItem = this.getOneItem(),
        uid = _getOneItem.uid,
        itemProps = _getOneItem.itemProps;

    var defaultItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()([uid]);
    var defaultItemProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, uid, itemProps));
    var _$route$query = this.$route.query,
        _$route$query$demoWid = _$route$query.demoWidth,
        demoWidth = _$route$query$demoWid === undefined ? 50 : _$route$query$demoWid,
        _$route$query$demoIte = _$route$query.demoItems,
        demoItems = _$route$query$demoIte === undefined ? defaultItems : _$route$query$demoIte,
        _$route$query$demoIte2 = _$route$query.demoItemProps,
        demoItemProps = _$route$query$demoIte2 === undefined ? defaultItemProps : _$route$query$demoIte2;


    this.width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils___["a" /* getValidDemoWidth */])(demoWidth);

    try {
      this.demoItems = JSON.parse(demoItems);
      this.demoItemProps = JSON.parse(demoItemProps);
    } catch (e) {
      this.demoItems = JSON.parse(decodeURIComponent(demoItems));
      this.demoItemProps = JSON.parse(decodeURIComponent(demoItemProps));
    }

    __WEBPACK_IMPORTED_MODULE_5__EventHub__["a" /* default */].$on('item-delete', function (theUID) {
      _this.demoItems = _this.demoItems.filter(function (item) {
        return theUID !== item;
      });

      _this.demoItemProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this.demoItemProps).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            key = _ref2[0];

        return theUID !== key;
      }).reduce(function (acc, _ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            val = _ref4[1];

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, val));
      }, {});
    });

    __WEBPACK_IMPORTED_MODULE_5__EventHub__["a" /* default */].$on('ctrl-width-change', function (width) {
      _this.width = width;
    });
  },


  computed: {
    demoContainerStyle: function demoContainerStyle() {
      return { flex: this.width };
    },
    demoStyle: function demoStyle() {
      return {
        'flex-wrap': this.demoProps.fw,
        'align-items': this.demoProps.ai,
        'align-content': this.demoProps.ac,
        'flex-direction': this.demoProps.fd,
        'justify-content': this.demoProps.jc
      };
    }
  },

  methods: {
    getOneItem: function getOneItem() {
      return {
        uid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils___["b" /* genOneUid */])(this.demoItems),
        itemProps: {
          order: 0,
          flexGrow: 0,
          flexShrink: 1,
          flexBasis: 'auto',
          alignSelf: 'auto'
        }
      };
    },
    addItem: function addItem() {
      var _getOneItem2 = this.getOneItem(),
          uid = _getOneItem2.uid,
          itemProps = _getOneItem2.itemProps;

      this.demoItems.push(uid);
      this.demoItemProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.demoItemProps, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, uid, itemProps));
    }
  },

  watch: {
    demoItems: function demoItems(newVal) {
      this.$router.push({
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
          demoItems: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newVal)
        })
      });
    },

    demoItemProps: {
      deep: true,
      handler: function handler(newVal) {
        this.$router.push({
          query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, {
            demoItemProps: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(newVal)
          })
        });
      }
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventHub__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Item',

  data: function data() {
    return {
      alignSelfArr: ['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']
    };
  },


  props: {
    num: {
      type: Number,
      isRequired: true
    },
    uid: {
      type: String,
      isRequired: true
    },
    itemProps: {
      order: {
        type: Number,
        default: 0
      },
      flexGrow: {
        type: Number,
        default: 0
      },
      flexShrink: {
        type: Number,
        default: 1
      },
      flexBasis: {
        type: [Number, String],
        default: 'auto'
      },
      alignSelf: {
        type: String,
        default: 'auto',
        validator: function validator(val) {
          return this.alignSelfArr.includes(val);
        }
      }
    }
  },

  computed: {
    itemStyle: function itemStyle() {
      return {
        'order': this.itemProps.order,
        'flex-grow': this.itemProps.flexGrow,
        'align-self': this.itemProps.alignSelf,
        'flex-basis': this.itemProps.flexBasis,
        'flex-shrink': this.itemProps.flexShrink
      };
    }
  },

  methods: {
    itemOnClick: function itemOnClick() {
      __WEBPACK_IMPORTED_MODULE_0__EventHub__["a" /* default */].$emit('item-delete', this.uid);
    },
    updateFlexBasis: function updateFlexBasis(value) {
      var tmpVal = this.itemProps.flexBasis;
      var number = value.replace(/[^\d.]/g, '');

      if (value === 'auto') {
        tmpVal = 'auto';
      } else if (value.slice(-1) === '%') {
        tmpVal = number + '%';
      } else if (number !== '') {
        tmpVal = number + 'px';
      }

      this.itemProps.flexBasis = tmpVal;
      this.$refs.basisInput.value = tmpVal;
    }
  }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(97),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(95),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(98),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f4dfe93",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(99),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctrl-container",
    style: (_vm.ctrlContainerStyle)
  }, [_c('span', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "divider"
  }), _c('ul', {
    attrs: {
      "id": "ctrl"
    }
  }, [_c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("Demo 宽度设置：" + _vm._s((_vm.demoWidth + "%")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.demoWidth),
      expression: "demoWidth",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    staticClass: "width-input",
    attrs: {
      "type": "range",
      "min": "20",
      "max": "75"
    },
    domProps: {
      "value": (_vm.demoWidth)
    },
    on: {
      "change": [function($event) {
        _vm.demoWidth = _vm._n($event.target.value)
      }, _vm.widthOnChange],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("弹性容器的属性说明")]), _c('ul', _vm._l((_vm.containerDescArr), function(desc) {
    return _c('li', [_vm._v(_vm._s(desc))])
  }))]), _c('li', {
    staticClass: "ctrl-item"
  }, [_vm._m(0), _c('div', {
    staticClass: "demo-props"
  }, _vm._l((_vm.containerFlexPropArr), function(item) {
    return _c('div', {
      staticClass: "container-prop-item"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._l((item.itemValues), function(value) {
      return _c('div', {
        staticClass: "ctrl-prop-item"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "id": ((item.prefix) + "-" + value),
          "value": "value"
        },
        domProps: {
          "checked": _vm.demoProps[item.prefix] === value
        },
        on: {
          "change": function($event) {
            _vm.propOnChange(( _obj = {}, _obj[item.prefix] = value, _obj ))
            var _obj;
          }
        }
      }), _c('label', {
        attrs: {
          "for": ((item.prefix) + "-" + value)
        }
      }, [_vm._v(_vm._s(value))])])
    })], 2)
  }))]), _c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("弹性子元素的属性说明")]), _c('ul', _vm._l((_vm.itemDescArr), function(desc) {
    return _c('li', [_vm._v(_vm._s(desc))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("弹性容器属性设置"), _c('span', {
    staticClass: "one-more-thing"
  }, [_vm._v("第一个为默认值！")])])
}]}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('CompDemo', {
    attrs: {
      "demoProps": _vm.demoProps
    }
  }), _c('div', {
    staticClass: "divider"
  }), _c('CompCtrl', {
    attrs: {
      "demoProps": _vm.demoProps
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-container",
    style: (_vm.demoContainerStyle)
  }, [_c('span', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _c('button', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加元素")])]), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    style: (_vm.demoStyle),
    attrs: {
      "id": "demo"
    }
  }, _vm._l((_vm.demoItems), function(uid, index) {
    return _c('CompDemoItem', {
      key: uid,
      attrs: {
        "num": index,
        "uid": uid,
        "itemProps": _vm.demoItemProps[uid]
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-item",
    style: (_vm.itemStyle)
  }, [_c('div', {
    staticClass: "demo-prop-item title"
  }, [_c('span', {
    staticClass: "num-bg"
  }, [_vm._v(_vm._s(_vm.num))]), _c('button', {
    staticClass: "delete-btn",
    on: {
      "click": _vm.itemOnClick
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("order:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.order),
      expression: "itemProps.order",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.itemProps.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.order = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-grow:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.flexGrow),
      expression: "itemProps.flexGrow",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.itemProps.flexGrow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.flexGrow = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-shrink:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.itemProps.flexShrink),
      expression: "itemProps.flexShrink",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.itemProps.flexShrink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemProps.flexShrink = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("flex-basis:")]), _c('input', {
    ref: "basisInput",
    domProps: {
      "value": _vm.itemProps.flexBasis
    },
    on: {
      "change": function($event) {
        _vm.updateFlexBasis($event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "demo-prop-item"
  }, [_c('span', {
    staticClass: "item-prop-text"
  }, [_vm._v("align-self:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemProps.alignSelf),
      expression: "itemProps.alignSelf"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.itemProps.alignSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.alignSelfArr), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  }))])])
},staticRenderFns: []}

/***/ })

},[39]);


// WEBPACK FOOTER //
// static/js/app.11613ccf7bee9be38886.js